module.exports = __webpack_public_path__ + "img/PRT.54c97f71.svg";